<template>
	<!-- 공통 템플릿 -->

	<!-- Style 적용 편의를 위해 RouterView Wrapping -->
	<div id="main-wrapper">
		<Sidebar/>
		<RouterView
			:key="$route.path"
			:toPath="toRoute?.path"
			:fromPath="fromRoute?.path"
		/>
	</div>
	<!-- <AppFooter></AppFooter> -->
</template>

<script>
import Sidebar from '@/components/app/Sidebar'
import {mapActions} from 'vuex'
import VueCookies from 'vue-cookies'

export default {
	components: {
		Sidebar
	},
	data() {
		return {
			showWarning : false,
			toRoute: null,
			fromRoute: null,
		}
	},
	watch: {
		'$route'(to, from) {
			//페이지가 이동할 때 상세일 경우에는 params 유지, 기타 페이지에서 이동할 경우에는 params reset
			this.toRoute = to;
			this.fromRoute = from;
		},
	},
	async created() {
		this.init()
	},
	methods: {
		...mapActions('user', ['autoLogin', 'getProfile']),
		init() {
			const token = VueCookies.get('token')
			if(token) {
				this.getProfile()
			} else {
				this.$router.push('/login')
			}
		}
	}
}
</script>
